import { useLazyQuery } from '@vue/apollo-composable';
import type { StudentPaginator, QueryStudentsArgs } from '@/types/composition-functions';

import { GET_STUDENTS } from '@/graphql';

// Define local extended type to avoid editing generated file
type ExtendedQueryStudentsArgs = QueryStudentsArgs & { include_tertiary?: boolean };

// useStudents.ts
export const useStudents = ({
  getStudentsOptions,
  studentFilters,
}: {
  getStudentsOptions: { autoFetch?: boolean };
  studentFilters?: Ref<ExtendedQueryStudentsArgs> | undefined; // ✅ fixed
}) => {
  const {
    result: studentsResult,
    loading: loadingStudents,
    error: studentsError,
    load: loadStudents,
    refetch: refetchStudents,
  } = useLazyQuery<{ students: StudentPaginator }, ExtendedQueryStudentsArgs>(
    GET_STUDENTS,
    studentFilters,
    { fetchPolicy: 'network-only' },
  );
  if (getStudentsOptions.autoFetch) loadStudents();

  const students = computed(() => studentsResult.value?.students?.data || []);
  const paginatorInfo = computed(() => studentsResult.value?.students?.paginatorInfo || null);

  return {
    students: {
      data: students,
      paginatorInfo,
      loading: loadingStudents,
      error: studentsError,
      refetch: refetchStudents,
    },
    loadStudents,
    refetchStudents,
    studentResults: students,
    hasStarted: computed(() => !!studentsResult.value),
  };
};
